import { Trans } from 'react-i18next';

import { Checkbox, Link, LinkTarget } from '@dreryk/react-components';

import { invoiceCreateAccountModalTranslationKeys } from '../../../translations';

import { InvoiceCreateAccountFormRegisterControllerProp } from './InvoiceCreateAccountForm.types';

const PRIVACY_POLICY_AND_GDPR_FIELD_NAME = 'privacyPolicyAndGdprAccepted';

type InvoiceCreateAccountFormPrivacyPolicyAndGdprCheckboxProps = InvoiceCreateAccountFormRegisterControllerProp & {
   readonly privacyPolicyAndGdprUrl: string;
};

export const InvoiceCreateAccountFormPrivacyPolicyAndGdprCheckbox = (
   props: InvoiceCreateAccountFormPrivacyPolicyAndGdprCheckboxProps
): JSX.Element => {
   return (
      <Checkbox
         controller={props.register(PRIVACY_POLICY_AND_GDPR_FIELD_NAME, { required: true })}
         testId={PRIVACY_POLICY_AND_GDPR_FIELD_NAME}
         label={
            <Trans
               i18nKey={invoiceCreateAccountModalTranslationKeys.privacyPolicyAndGdprLabel}
               components={{
                  link: (
                     <Link
                        block={false}
                        href={props.privacyPolicyAndGdprUrl}
                        label={invoiceCreateAccountModalTranslationKeys.privacyPolicyAndGdpr}
                        target={LinkTarget.BLANK}
                        testId={'goToPrivacyPolicyAndGdpr'}
                     />
                  ),
               }}
            />
         }
      />
   );
};
